import PropTypes from 'prop-types';
import { WarningIcon } from '../../assets/icons';
import Spinner from '../common/Spinner';
import useModalClose from '../../hooks/useModalClose';
import { useState } from 'react';

const DeleteAssignmentModal = ({ isOpen, onClose, onSuccess, assignmentId }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useModalClose(isOpen, onClose);

  const handleDelete = async () => {
    setIsLoading(true);
    setError(null);

    try {
      const response = await fetch(`https://apiizdonusum.izmirteknoloji.com.tr/AssignmentDelete/${assignmentId}`, {
        method: 'DELETE',
        headers: {
          'accept': '*/*',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      const data = await response.json();

      if (data.status === 200) {
        onSuccess(assignmentId);
        onClose();
      } else {
        setError(data.message || 'Görevlendirme silinirken bir hata oluştu.');
      }
    } catch (error) {
      console.error('Failed to delete assignment:', error);
      setError('Görevlendirme silinirken bir hata oluştu.');
    } finally {
      setIsLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content delete-assignment-modal" onClick={e => e.stopPropagation()}>
        {isLoading ? (
          <div className="loading-state">
            <Spinner size="large" />
            <h3>Görevlendirme siliniyor...</h3>
          </div>
        ) : (
          <>
            <div className="modal-header">
              <WarningIcon />
            </div>
            <div className="modal-body">
              <h3 className='delete-assignment-modal-title'>Görevlendirmeyi silmek istediğinize emin misiniz?</h3>
              {error && <div className="error-message">{error}</div>}
            </div>
            <div className="modal-actions">
              {error ? (
                <button 
                  type="button" 
                  className="cancel-button delete-assignment-modal-retry"
                  onClick={handleDelete}
                >
                  Tekrar dene
                </button>
              ) : (
                <>
                  <button 
                    type="button" 
                    className="cancel-button delete-assignment-modal-cancel"
                    onClick={onClose}
                  >
                    Hayır, vazgeçtim
                  </button>
                  <button 
                    type="button" 
                    className="delete-button delete-assignment-modal-proceed"
                    onClick={handleDelete}
                  >
                    Evet, eminim
                  </button>
                </>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

DeleteAssignmentModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  assignmentId: PropTypes.string.isRequired
};

export default DeleteAssignmentModal; 